var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg29(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_96484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1479 13.1703C17.6981 12.2625 18.0152 11.1983 18.0152 10.0613V0.5H5.98348V10.0613C5.98348 11.1983 6.30059 12.2625 6.85085 13.1703H6.85081C3.86374 13.1703 1.43359 15.6005 1.43359 18.5876V24.5H22.5651V18.5876C22.565 15.6005 20.1348 13.1703 17.1479 13.1703ZM7.38612 1.90269H16.6124V4.6521H7.38612V1.90269ZM16.6125 6.05475V7.06893H16.6125C15.949 7.3844 15.1935 7.5503 14.4036 7.5503C12.9347 7.5503 11.6068 6.96708 10.8455 6.05475H16.6125ZM7.38612 6.0547H9.18612C9.18748 6.05751 9.1888 6.06037 9.19016 6.06314C8.80719 6.76818 8.15183 7.27087 7.38612 7.46339V6.0547ZM7.38612 8.895C8.46195 8.71744 9.41933 8.13684 10.0716 7.27734C10.3507 7.55526 10.6686 7.80731 11.0203 8.02514C12.0006 8.63212 13.1705 8.95303 14.4035 8.95303C15.1729 8.95303 15.9202 8.82633 16.6124 8.58338V10.0614C16.6124 12.6052 14.5429 14.6747 11.9992 14.6747C9.45551 14.6747 7.38603 12.6052 7.38603 10.0614V8.895H7.38612ZM2.83628 23.0974V18.5876C2.83628 16.374 4.63722 14.5731 6.85081 14.5731H8.02465C9.08534 15.5087 10.4771 16.0772 11.9993 16.0772C13.5215 16.0772 14.9132 15.5087 15.9739 14.5731H17.1478C19.3614 14.5731 21.1623 16.374 21.1623 18.5876V23.0974H2.83628Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8228 20.2891H10.1758V21.6918H13.8228V20.2891Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8228 17.4824H10.1758V18.8851H13.8228V17.4824Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_96484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg29);
export default __webpack_public_path__ + "static/media/29.663025abeb4d74bae873c483d1949489.svg";
export { ForwardRef as ReactComponent };